import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Öneri silme sırasında oluşan hatayı işler
 * @param {Error} error - Oluşan hata
 * @param {String|Number} id - Silinmeye çalışılan önerinin ID'si
 * @returns {Object} Hata yanıtı: {success, message, error}
 */
export const handleError = (error, id) => {
  console.error(`Error deleting suggestion with id ${id}:`, error)

  const errorMessage = error.message || 'Öneri silinirken bir hata oluştu'
  responseHandlerService.handleError(error, errorMessage)

  return {
    success: false,
    message: errorMessage,
    error,
    data: null,
  }
}